import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.h6`
  margin: 0;
  padding: 0 16px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  text-align: center;

  @media screen and (min-width: ${DESKTOP}px) {
    padding: 0 40px;
  }
`;
